import React from "react";
import {Card, Tabs} from "antd";
import InvoiceDetailForm from "./InvoiceDetailForm";
import InvoiceDetailList from "./InvoiceDetailList";


export default function () {

    return (
        <Card
            // title={<h3>采购发运单明细</h3>}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <InvoiceDetailForm/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="发运单明细" key="2">
                    <InvoiceDetailList/>
                </Tabs.TabPane>

            </Tabs>

        </Card>
    )
};